// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import MintUI from 'mint-ui';
import 'mint-ui/lib/style.css'
import router from './router';
import wx from 'weixin-js-sdk'

import VueScroller from "vue-scroller"
Vue.use(VueScroller);

import Vconsole from 'vconsole'
if (location.href.indexOf("_DEBUG")>-1) {
  new Vconsole()    
}
// const vConsole = new Vconsole()
// Vue.use(vConsole)

Vue.config.productionTip = false

Vue.use(MintUI);
let vue = new Vue({
  el: '#app',
  router,
  mounted() {
    szRem();
  },
  components: { App },
  template: '<App/>'
})
function szRem() {
  let width = 750;
  let whdef = 100 / width; // 表示750的设计图,使用100PX的默认值
  let wW = document.documentElement.clientWidth || window.innerWidth; // 当前窗口的宽度
  console.log('输出看看:',wW);
  let rem = wW * whdef; // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应font-size值
  document.getElementsByTagName('html')[0].style.fontSize = rem + "px";
}
window.addEventListener('load', szRem);
window.addEventListener('resize', szRem);
export default vue



// WEBPACK FOOTER //
// ./src/main.js